<template>
  <div
    id="service-intro-page"
    :class="{ 'empty': serviceIsNotAvaliable }"
  >
    <template v-if="serviceIsNotAvaliable">
      <ServiceNotAvaliable />
    </template>
    <div
      v-else-if="!isLoading"
      class="page-content"
    >
      <div
        v-if="!isMobile"
        class="section-container"
      >
        <div class="service-breadcrumb">
          <nuxt-link
            :to="{ name: 'home' }"
            class="service-breadcrumb__item"
          >
            首頁
          </nuxt-link>
          <i class="icon icon-chevron-right service-breadcrumb__arrow" />
          <nuxt-link
            :to="{ name: 'index-id', params: { id: category } }"
            class="service-breadcrumb__item"
          >
            {{ categoryName }}
          </nuxt-link>
          <i class="icon icon-chevron-right service-breadcrumb__arrow" />
          <span class="service-breadcrumb__item service-breadcrumb__item--active">{{ serviceName }}</span>
        </div>
      </div>
      <div
        :class="{'section-container': !isMobile}"
      >
        <div class="service-top-section">
          <div class="service-top-section__left">
            <div class="service-banner">
              <div
                v-if="bannerList.length"
                ref="bannerSwiper"
                v-swiper:bannerSwiper="bannerSwiperParams"
                class="banner-swiper"
              >
                <div class="swiper-wrapper">
                  <div
                    v-for="(banner, index) in bannerList"
                    :key="index"
                    class="swiper-slide banner-swiper__slide"
                  >
                    <img
                      class="banner-swiper__image"
                      :src="banner"
                      :alt="`${serviceName}-${serviceDetails.service_desc}`"
                    >
                  </div>
                </div>
              </div>
              <div
                v-else
                class="service-banner__empty"
              >
                <img
                  src="@/assets/image/logo@2x.png"
                  class="service-banner__logo"
                  alt="服務banner"
                >
              </div>
            </div>
            <div
              v-if="!isMobile && canShowPromotion"
              class="promotion-section"
            >
              <div class="promotion-section__title">
                優惠活動
              </div>
              <promotion-list />
            </div>
          </div>
          <div class="service-top-section__right">
            <div :class="{'section-container with-mb is-top': isMobile}">
              <ServiceInfoHeader
                :service-name="serviceName"
                :rating-average="introData.ratingAverage"
                :rating-amount="introData.ratingAmount"
                :completed-order-count="introData.completedOrderCount"
                :recommended-selling-price="introData.RecommendedSellingPrice"
                :highlight-tag="highlightTag"
                :is-card="false"
                @scrollToRating="selectTab('評價', 0)"
              />
            </div>
            <div
              v-if="introData.order_mode_id === 1 || introData.OverviewDescription"
              :class="{'section-container with-mb with-paddingY': isMobile}"
            >
              <div
                v-if="introData.order_mode_id === 1"
                class="payment-list"
              >
                <i class="icon-payment-method payment-list__icon" />
                <div
                  v-if="introData.paymentType.includes(4)"
                  class="payment-list__item"
                >
                  現金
                </div>
                <div
                  v-if="introData.paymentType.includes(1)"
                  class="payment-list__item"
                >
                  信用卡
                </div>
                <div
                  v-if="introData.paymentType.includes(2)"
                  class="payment-list__item"
                >
                  ATM轉帳
                </div>
                <div
                  v-if="introData.paymentType.includes(8)"
                  class="payment-list__item"
                >
                  <img
                    class="payment-list__image apple-pay"
                    src="@/assets/image/payment/apple-pay.svg"
                    alt="apple-pay"
                  >
                </div>
                <div
                  v-if="introData.paymentType.includes(7)"
                  class="payment-list__item"
                >
                  <img
                    class="payment-list__image google-pay"
                    src="@/assets/image/payment/google-pay.svg"
                    alt="google-pay"
                  >
                </div>
                <div
                  v-if="introData.paymentType.includes(5)"
                  class="payment-list__item"
                >
                  <img
                    class="payment-list__image plus-pay"
                    src="@/assets/image/payment/plus-pay-horizontal.svg"
                    alt="plus-pay"
                  >
                </div>
              </div>
              <div
                v-if="introData.order_mode_id === 1 && introData.OverviewDescription && isMobile"
                class="horizontal-divider"
              />
              <div
                v-if="introData.OverviewDescription"
                class="brief-content"
                :style="{ maxHeight: contentMaxHeight }"
              >
                <div
                  ref="briefContentText"
                  class="brief-content__text"
                  v-html="introData.OverviewDescription"
                />
                <div
                  v-if="!serviceOverview.isContentExpanded && canShowToggleContentBtn"
                  class="brief-content__gradient"
                />
              </div>
              <button
                v-if="canShowToggleContentBtn"
                class="brief-content__toggle"
                @click="toggleContent"
              >
                <span>{{ serviceOverview.isContentExpanded ? '收合內容' : '查看更多' }}</span>
              </button>
            </div>
            <div
              v-if="!isMobile"
              class="service-top-section__btn"
            >
              <v-btn
                v-if="!redirection"
                depressed
                color="primary"
                class="purchase-btn"
                @click="goToPurchasePage"
              >
                {{ purchaseBtnText }}
              </v-btn>
              <v-btn
                v-else
                depressed
                color="primary"
                class="purchase-btn"
                @click="goToRedirectionPage"
              >
                立即前往
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <!-- 手機版優惠 -->
      <div
        v-if="isMobile && canShowPromotion"
        class="mobile-promotion"
      >
        <promotion-list />
      </div>
      <div class="tab-swiper__wrapper">
        <div
          id="tab-swiper"
          class="tab-swiper__container"
          :class="[tabControl.scrollStatus ? 'scroll-fixed' : '']"
        >
          <div
            ref="tabSwiper"
            v-swiper:tabSwiper="tabSwiperParams"
            :class="{'section-container': !isMobile}"
          >
            <div class="swiper-wrapper">
              <div
                v-for="(tab, tabIndex) in tabOptions"
                :key="tabIndex"
                class="swiper-slide"
                @click="selectTab(tab, tabIndex)"
              >
                {{ tab }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="canShowRatingInfo">
        <div class="section-container">
          <div class="rating-section scroll-target-section">
            <h2 class="section-container__title">
              評價
            </h2>
            <button
              v-if="!isMobile"
              class="rating-section__btn"
              @click="handleRatingPopupSwitch(true)"
            >
              <span>查看所有評價</span>
              <i class="icon icon-arrow-right-bold" />
            </button>
          </div>
          <RatingSummary
            :rating-average="introData.ratingAverage"
            :rating-amount="introData.ratingAmount"
          />
        </div>
        <div class="rating-swiper-section">
          <div class="rating-swiper-section__container">
            <div
              v-if="ratingData.topFiveList.length"
              ref="ratingSwiper"
              v-swiper:ratingSwiper="ratingSwiperParams"
              class="rating-swiper"
            >
              <div class="swiper-wrapper">
                <div
                  v-for="data in ratingData.topFiveList"
                  :key="data.order_id"
                  class="swiper-slide rating-swiper__slide"
                >
                  <RatingCard
                    :rating="data"
                    :is-list="false"
                    @click="seeRatingDetail"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="isMobile"
              class="mobile-rating-more"
            >
              <v-btn
                depressed
                color="secondary"
                class="mobile-rating-more__btn"
                @click="handleRatingPopupSwitch(true)"
              >
                查看更多
              </v-btn>
            </div>
          </div>
          <!-- 導航按鈕 -->
          <div
            v-if="!isMobile"
            class="swiper-arrow-controls"
          >
            <v-btn
              class="rating-swiper-button rating-swiper-button--prev"
              fab
            >
              <i class="icon icon-arrow-left-bold" />
            </v-btn>
          </div>
          <div
            v-if="!isMobile"
            class="swiper-arrow-controls"
          >
            <v-btn
              class="rating-swiper-button rating-swiper-button--next"
              fab
            >
              <i class="icon icon-arrow-right-bold" />
            </v-btn>
          </div>
        </div>
      </template>
      <div class="detail-section section-container">
        <div class="service-detail-wrap">
          <div
            id="service-intro"
            class="section-container__title with-mb scroll-target-section"
          >
            服務介紹
          </div>
          <div
            class="v-html-content"
            v-html="introData.content"
          />
          <div class="section-container__title with-mb scroll-target-section">
            價格方案
          </div>
          <div
            class="v-html-content"
            v-html="introData.price_plan"
          />
          <template v-if="!canShowRatingInfo && introData.service_ratings">
            <div class="section-container__title with-mb scroll-target-section">
              用戶好評
            </div>
            <div
              class="v-html-content"
              v-html="introData.service_ratings"
            />
          </template>
          <div class="section-container__title with-mb scroll-target-section">
            常見問題
          </div>
          <div
            class="v-html-content"
            v-html="introData.note"
          />
        </div>
        <div
          v-show="showStickyCard"
          class="sticky-card"
        >
          <ServiceInfoHeader
            :service-name="serviceName"
            :rating-average="introData.ratingAverage"
            :rating-amount="introData.ratingAmount"
            :completed-order-count="introData.completedOrderCount"
            :recommended-selling-price="introData.RecommendedSellingPrice"
            :is-card="true"
            @scrollToRating="selectTab('評價', 0)"
          />
          <div class="sticky-card__bottom">
            <v-btn
              v-if="!redirection"
              depressed
              color="primary"
              class="purchase-btn"
              @click="goToPurchasePage"
            >
              {{ purchaseBtnText }}
            </v-btn>
            <v-btn
              v-else
              depressed
              color="primary"
              class="purchase-btn"
              @click="goToRedirectionPage"
            >
              立即前往
            </v-btn>
          </div>
        </div>
      </div>
      <div class="service-contact section-container">
        <div
          id="contact-us"
          class="section-container__title scroll-target-section"
        >
          聯絡我們
        </div>
        <div class="service-contact__wrap">
          <p class="service-contact__text">
            如有任何疑問、無法訂購或想進一步了解，請加官方LINE@與我們聯繫。
          </p>
          <img
            src="~/assets/image/line-text.png"
            alt="line"
            class="line-button"
            @click="goDailyProLine"
          >
        </div>
      </div>
      <div
        v-if="isMobile"
        class="service-bottom-fixed"
      >
        <v-btn
          v-if="!redirection"
          depressed
          color="primary"
          class="purchase-btn"
          @click="goToPurchasePage"
        >
          {{ purchaseBtnText }}
        </v-btn>
        <v-btn
          v-else
          depressed
          color="primary"
          class="purchase-btn"
          @click="goToRedirectionPage"
        >
          立即前往
        </v-btn>
      </div>
      <transition name="fade">
        <div
          v-if="canShowPlatformConsultationBtn"
          class="float-btn"
        >
          <transition name="fade">
            <div
              v-show="platformConsultationTooltip.canShow"
              class="float-btn__tooltip"
            >
              <div class="float-btn__tooltip-header u-display-flex-between">
                <div class="float-btn__tooltip-title">
                  有問題來聊聊
                </div>
                <i
                  class="icon-close float-btn__tooltip-icon"
                  @click.prevent="closePlatformConsultationTooltip"
                />
              </div>
              <div class="float-btn__tooltip-content">
                服務內容、方案、預約方式都可以詢問喔
              </div>
            </div>
          </transition>
          <img
            src="~/assets/image/quokka/quokka-platform-consultation.png"
            alt="有問題來聊聊"
            class="float-btn__image"
            @click="goQuickConsultation"
          >
        </div>
      </transition>
      <bottom-up-modal
        id="rating-dialog"
        :prop-show="ratingPopupSwitch"
        prop-title="用戶好評"
        @close="ratingPopupSwitch = false"
      >
        <template #content>
          <div
            ref="ratingDialogContent"
            class="rating-dialog-content"
            @scroll="handleRatingDialogScroll"
          >
            <RatingSummary
              :rating-average="introData.ratingAverage"
              :rating-amount="introData.ratingAmount"
            />
            <div
              v-for="data in ratingData.allList"
              :key="data.order_id"
              :data-order-id="data.order_id"
              class="rating-card-list"
            >
              <RatingCard
                :rating="data"
                :is-list="true"
              />
            </div>
            <div
              v-if="ratingData.isLoadingMore"
              class="rating-loading-more"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                size="24"
              />
            </div>
            <div
              v-if="ratingData.noMore && ratingData.allList.length > 0"
              class="rating-no-more"
            >
              已顯示全部評價
            </div>
          </div>
        </template>
      </bottom-up-modal>
    </div>
    <bottom-up-modal
      :prop-show="isShowNotServeModal"
      prop-title="服務範圍"
      @close="isShowNotServeModal = false"
    >
      <template #content>
        <div class="not-in-serve-wrap">
          <not-in-serve
            :reason="notInServeReason"
            :city-area-list="serviceData && serviceData.CityAreaList || []"
            hide-title
          />
        </div>
      </template>
    </bottom-up-modal>
  </div>
</template>

<script>
import serviceSSR from '@/mixin/serviceSSR'
import checkServiceAvailable from '@/mixin/checkServiceAvailable'
import ServiceNotAvaliable from '@/components/Error/ServiceNotAvaliable.vue'
import { mapState, mapGetters } from 'vuex'
import BottomUpModal from '@/components/Modal/BottomUpModal.vue'
import NotInServe from '@/components/PurchaseSteps/NotInServe.vue'
import ServiceInfoHeader from '../components/ServiceInfoHeader.vue'
import RatingSummary from '../components/RatingSummary.vue'
import RatingCard from '../components/RatingCard.vue'
import PromotionList from '@/components/PurchaseSteps/PromotionList.vue'
import getServiceLineLink from '@/utils/getServiceLineLink'

export default {
  name: 'ServiceIntro',
  components: {
    BottomUpModal,
    ServiceNotAvaliable,
    ServiceInfoHeader,
    RatingSummary,
    RatingCard,
    PromotionList,
    NotInServe
  },
  mixins: [serviceSSR, checkServiceAvailable],
  data () {
    return {
      serviceId: null,
      serviceName: '',
      category: null,
      categoryName: null,
      image: null,
      isOpen: null,
      keywords: null,
      metaTitle: null,
      redirection: null, // 導購制服務
      introData: null,
      ratingPagination: {
        offset: 5,
        maxCount: 10,
        total: 0
      },
      ratingData: {
        topFiveList: [],
        allList: [],
        orderIdToScroll: null,
        isLoadingMore: false,
        noMore: false
      },
      bannerSwiperParams: {
        loop: true,
        watchOverflow: true,
        touchEventsTarget: 'wrapper',
        preloadImages: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        slidesPerView: 1
      },
      showStickyCard: false,
      allTabOptions: [
        '評價', '服務介紹', '價格方案', '用戶好評', '常見問題', '聯絡我們'
      ],
      ratingPopupSwitch: false,
      promotionPopupSwitch: false,
      isLoading: true,
      highlightTag: {
        iconName: '',
        typeName: ''
      },
      tabControl: {
        scrollStatus: false,
        isSmoothScrolling: false,
        selectedIndex: 0
      },
      serviceOverview: {
        isContentExpanded: false,
        collapsedHeight: '7em',
        expandedHeight: null
      },
      communityList: [],
      notInServeReason: '',
      isShowNotServeModal: false,
      platformConsultationTooltip: {
        canShow: false,
        hasClosed: false
      },
      canClick: true
    }
  },
  head () {
    return {
      title: this.metaTitle,
      meta: [
        { hid: 'title', name: 'title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'keywords', name: 'keywords', content: this.keywords },
        { hid: 'og:url', property: 'og:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'og:title', property: 'og:title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'og:description', property: 'og:description', content: this.description },
        this.image ? { hid: 'og:image', property: 'og:image', content: this.image } : {},
        { hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:url', property: 'twitter:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'twitter:title', property: 'twitter:title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'twitter:description', property: 'twitter:description', content: this.description },
        this.image ? { hid: 'twitter:image', property: 'twitter:image', content: this.image } : {},
        { hid: 'robots', name: 'robots', content: this.isOpen && this.$nuxt.context.env.NODE_ENV_NAME === 'ec' ? 'all' : 'noindex' },
        { hid: 'googlebot', name: 'googlebot', content: this.isOpen && this.$nuxt.context.env.NODE_ENV_NAME === 'ec' ? 'all' : 'noindex' }
      ]
    }
  },
  jsonld () {
    if (this.redirection) return null // 導購制服務不需提供結構化資料
    const baseUrl = String(this.$nuxt.context.env.BASE_WEB_URL || ' ').slice(0, -1)
    const serviceRouteData = this.$nuxt.$router.resolve({
      name: 'category-category-service',
      params: {
        service: this.serviceId,
        category: this.category
      }
    })
    const currentServiceUrl = baseUrl + serviceRouteData.resolved.fullPath
    const getBreadcrumbList = () => {
      const categoryRoute = this.$nuxt.$router.resolve({
        name: 'index-id',
        params: {
          id: this.category
        }
      })
      const categoryUrl = baseUrl + categoryRoute.resolved.fullPath
      return [
        {
          '@type': 'ListItem',
          position: 1,
          name: this.$store.state.meta.title,
          item: baseUrl
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: this.categoryName,
          item: categoryUrl
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: this.metaTitle,
          item: currentServiceUrl
        }
      ]
    }
    return {
      '@context': 'http://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: getBreadcrumbList()
        }
      ]
    }
  },
  computed: {
    ...mapState(['url', 'isApp']),
    ...mapState('service', ['allServiceList', 'serviceData']),
    ...mapState('purchaseStore', ['promotion']),
    ...mapGetters(['isMobile']),
    ...mapGetters('purchaseStore', ['canShowPromotion']),
    serviceData () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    },
    serviceIsNotAvaliable () {
      return this.serviceData?.is_check !== 1
    },
    bannerList () {
      return this.$store.getters['service/getBannerList'](this.serviceId)
    },
    isTaxiService () {
      return this.redirection?.uri && this.checkTaxiServiceDomain(this.redirection.uri)
    },
    isCommunity () {
      return this.serviceData?.serviceAddressMode?.id === 2
    },
    canShowRatingInfo () {
      return Boolean(this.introData?.ratingAverage) && (this.introData?.order_mode_id !== 2 || this.isTaxiService)
    },
    canShowCompletedOrderInfo () {
      return this.introData?.completedOrderCount && this.introData?.order_mode_id === 1
    },
    isQuotationMode () {
      return this.introData?.NegotiateModeId === 2
    },
    canShowPlatformConsultationBtn () {
      return this.introData?.is_platform_consultation && this.isApp
    },
    purchaseBtnText () {
      if (this.introData?.serviceProcessMode === 'AppointedStore') {
        return '選購方案'
      } else if (this.introData?.IsProductMode) {
        return '點我訂購'
      } else if (this.introData?.order_mode_id === 3) {
        return '點我諮詢'
      }
      return '點我預約'
    },
    tabSwiperParams () {
      return {
        slidesPerView: 'auto',
        freeMode: true
      }
    },
    tabOptions () {
      if (!this.canShowRatingInfo) {
        return this.allTabOptions.filter(tab => tab !== '評價')
      }
      return this.allTabOptions.filter(tab => tab !== '用戶好評')
    },
    ratingSwiperParams () {
      if (this.isMobile) {
        return {
          slidesPerView: 1.2,
          spaceBetween: 8,
          speed: 500,
          resistance: true,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16
        }
      }
      return {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 16,
        loop: true,
        watchOverflow: true,
        touchEventsTarget: 'wrapper',
        preloadImages: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        freeMode: true,
        navigation: {
          nextEl: '.rating-swiper-button--next',
          prevEl: '.rating-swiper-button--prev'
        }
      }
    },
    contentMaxHeight () {
      return this.serviceOverview.isContentExpanded ? this.serviceOverview.expandedHeight + 'px' : this.serviceOverview.collapsedHeight
    },
    canShowToggleContentBtn () {
      return this.serviceOverview.expandedHeight > parseFloat(this.serviceOverview.collapsedHeight)
    },
    cityList () {
      return this.$store.getters['service/regionList'](this.serviceId)
    },
    openComIdArr () {
      return this.introData?.ServiceOpenCommunity.map(v => v.ComId) || []
    },
    removeComIdArr () {
      return this.introData?.ServiceRemoveCommunity.map(v => v.ComId) || []
    }
  },
  async mounted () {
    try {
      this.isLoading = true
      this.getServiceIntro()
      this.getHighlightTag()
      await this.fetchScoreStatistic()
      await this.fetchPromotion()
      await this.fetchRatingData(0, 5, 'top')
      if (this.isCommunity) { // 社區模式
        await this.setCommunityList()
        this.notInServeReason = this.getNotInServeReason() // 更新無法服務原因
        this.listenLooggedIn()
        if (this.$auth.loggedIn && this.isFromTicket) {
          if (this.notInServeReason === 'noServiceCommunity') {
            this.$alert({
              title: '系統提示',
              message: '該服務無法於您所在的區域使用，請確認適用範圍',
              persistent: true,
              btn: [
                {
                  btnText: '確定',
                  btnColor: 'primary',
                  btnClick: () => {
                    this.$alert.close()
                    this.$router.push({ name: 'member-ticket' })
                  }
                }
              ]
            })
          }
        }
      }
      setTimeout(() => {
        if (!this.platformConsultationTooltip.hasClosed && this.canShowPlatformConsultationBtn) {
          this.platformConsultationTooltip.canShow = true
        }
      }, 10000)
      this.isLoading = false
      this.$nextTick(async () => {
        if (this.$refs.briefContentText) {
          this.serviceOverview.expandedHeight = this.$refs.briefContentText.scrollHeight
        }
        await this.$awaitSetTimeout(300)
        window.addEventListener('scroll', this.handlePageScroll)
        this.changeTab(0)
      })
      this.$eventHub.reportAll('PageView', {
        page: '商品頁',
        serviceId: `${this.serviceData.service_id}`,
        serviceTitle: this.serviceData.service_title,
        serviceMainType: `${this.serviceData.type_parent}`,
        serviceSubType: `${this.serviceData.type_id}`
      })
    } catch (error) {
      console.log('error', error)
    }
  },
  beforeDestroy () {
    this.$alert.close()
    window.removeEventListener('scroll', this.handlePageScroll)
    window.removeEventListener('scroll', this.handleDeskopScroll)
  },
  methods: {
    // 母分類名稱
    getCategoryName (typeId) {
      const category = _.find(this.allServiceList, { typeParent: parseInt(typeId) })
      return category ? category.mainTypeName : ''
    },
    async getServiceIntro () {
      this.introData = {
        ...this.serviceData,
        completedOrderCount: this.serviceData.Statistics.SameSubcategoryOrderCount,
        paymentType: this.serviceData.PaymentTypeWithPaymentTiming.map(item => item.PaymentTypeId),
        serviceProcessMode: this.serviceData.ServiceProcessMode?.Mode
      }
    },
    async fetchScoreStatistic () {
      try {
        const { data } = await this.$axios.get(`/api/Main/${this.serviceId}/Score/Statistic`)
        this.introData.ratingAverage = data.Data.SameSubcategory.AverageScore
        this.introData.ratingAmount = data.Data.SameSubcategory.Count
        this.ratingPagination.total = this.introData?.ratingAmount || 0
      } catch (error) {
        console.log('fetchScoreStatisticError', error)
        return Promise.reject(error)
      }
    },
    async fetchPromotion () {
      if (this.isQuotationMode || this.redirection) return
      await this.$store.dispatch('purchaseStore/fetchPromotionData', this.serviceId).catch(error => {
        return Promise.reject(error)
      })
    },
    async fetchRatingData (offset, maxCount, type) {
      try {
        if (!this.introData.ratingAmount) return
        const { Data } = await this.$axios.$get('/api/v2/Main/GetScores', {
          params: {
            service_id: this.serviceId,
            Offset: offset,
            MaxCount: maxCount
          }
        })
        const scoreList = Data.scores.map(score => {
          score.pictureList = score.ScorePictureList.sort((a, b) => a.IsAfter - b.IsAfter).map(pic => pic.FilePath).slice(0, 3)
          score.tagList = score.ScoreTagList.slice(0, 3)
          score.anonymousName = this.maskMemberName(score.name)
          score.place = score.Community ? score.Community.Name + ' 社區' : score.city + score.area
          score.time = this.$dayjs(score.score_time).format('YYYY/MM/DD')
          score.replyContent = score.reply_detail.length ? score.reply_detail.slice(-1)[0].reply_content.replace(/\n/g, '<br>') : ''
          score.replyTime = score.reply_detail.length ? this.$dayjs(score.reply_detail.slice(-1)[0].reply_time).format('YYYY/MM/DD') : ''
          return score
        })
        if (type === 'top') {
          this.ratingData.topFiveList = scoreList
        }
        if (type === 'all') {
          this.ratingData.allList = this.ratingData.allList.length ? [...this.ratingData.allList, ...scoreList] : [...this.ratingData.topFiveList, ...scoreList]
        }
      } catch (error) {
        console.log('fetchRatingDataError', error)
        return Promise.reject(error)
      }
    },
    checkTaxiServiceDomain (url) {
      // 叫車服務允許的網域清單
      const TAXI_DOMAINS = [
        'https://taxi-dev.kingnetsmart.com.tw',
        'https://taxi-staging.kingnetsmart.com.tw',
        'https://taxi.kingnetsmart.com.tw'
      ]
      const urlObject = new URL(url)
      // 取得完整的 origin (protocol + hostname + port)
      const urlOrigin = urlObject.origin
      return TAXI_DOMAINS.includes(urlOrigin)
    },
    getHighlightTag () {
      const category = _.find(this.allServiceList, { typeParent: -999 }) // 精選分類
      if (!category) return
      const service = _.find(category.Main, { serviceId: this.serviceId })
      if (!service) return
      this.highlightTag.iconName = service.iconName
      this.highlightTag.typeName = service.typeName
    },
    maskMemberName (name) {
      const nameLength = name.length
      if (nameLength <= 2) return name[0] + '*'.repeat(nameLength - 1)
      const middleMask = nameLength <= 6 ? '*'.repeat(nameLength - 2) : '*'.repeat(4)
      return name[0] + middleMask + name[nameLength - 1]
    },
    handlePromotionPopupSwitch (status) {
      this.promotionPopupSwitch = status
    },
    toggleContent () {
      this.serviceOverview.isContentExpanded = !this.serviceOverview.isContentExpanded
    },
    listenLooggedIn () {
      this.$auth.$storage.watchState('loggedIn', async (loggedIn) => {
        if (loggedIn) {
          await this.setCommunityList()
        }
        this.notInServeReason = this.getNotInServeReason()
      })
    },
    selectTab (tabName, tabIndex) {
      this.changeTab(tabIndex)
      this.tabControl.isSmoothScrolling = true
      const tabSwiperElementHeight = document.getElementById('tab-swiper').offsetHeight || 45
      const targetSection = document.querySelectorAll('.scroll-target-section')[tabIndex]

      if (!targetSection) {
        this.tabControl.isSmoothScrolling = false
        return
      }

      const targetTop = targetSection.offsetTop
      const scrollTargetPosition = targetTop - tabSwiperElementHeight - 24

      let scrollEndTimer = null

      const checkScrollEnd = () => {
        // 清除之前的計時器
        if (scrollEndTimer) {
          clearTimeout(scrollEndTimer)
        }

        // 當滾動停止 150ms 後才認為滾動結束
        scrollEndTimer = setTimeout(() => {
          this.tabControl.isSmoothScrolling = false
          window.removeEventListener('scroll', checkScrollEnd)
        }, 150)
      }

      window.addEventListener('scroll', checkScrollEnd)
      window.scrollTo({
        top: scrollTargetPosition,
        behavior: 'smooth'
      })
      this.tabControl.selectedIndex = tabIndex
      this.$gaLogEvent('商品頁', `tab_${tabName}`)
    },
    changeTab (tabIndex) {
      const tabSwiperElement = document.getElementById('tab-swiper')
      if (!tabSwiperElement) return
      if (this.tabControl.isSmoothScrolling) return
      if (tabSwiperElement.querySelector('.swiper-slide.selected') && tabSwiperElement.querySelector('.swiper-slide.selected') != null) {
        tabSwiperElement.querySelector('.swiper-slide.selected').classList.remove('selected')
      }
      tabSwiperElement.querySelectorAll('.swiper-slide')[tabIndex].classList.add('selected')
      this.tabControl.selectedIndex = tabIndex
      this.$refs.tabSwiper.swiper.slideTo(tabIndex - 1, 0)
    },
    handlePageScroll (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      )
      const offsetHeight = window.innerHeight
      const scrollRatio = Math.round(scrollTop / (scrollHeight - offsetHeight) * 100)
      if (!this.platformConsultationTooltip.canShow && !this.platformConsultationTooltip.hasClosed && scrollRatio > 25) {
        this.platformConsultationTooltip.canShow = true
      }
      const tabSwiperElement = document.getElementById('tab-swiper')
      const tabSwiperElementHeight = tabSwiperElement.offsetHeight
      const navbarHeight = document.getElementById('header').offsetHeight
      const scrollTargetSection = document.querySelectorAll('.scroll-target-section')
      const firstSectionTop = scrollTargetSection[0].offsetTop
      let shouldShowTab = scrollTop >= (firstSectionTop - navbarHeight)
      if (this.isMobile) {
        shouldShowTab = scrollTop >= (firstSectionTop - navbarHeight - 24) // 減去手機版的 paddingY
      }

      if (shouldShowTab) {
        this.tabControl.scrollStatus = true
        tabSwiperElement.style.top = navbarHeight + 'px'
      } else {
        this.tabControl.scrollStatus = false
        tabSwiperElement.style.top = 0
      }

      if (this.tabControl.isSmoothScrolling) return

      if (!scrollTargetSection.length) return
      const checkHeight = navbarHeight + tabSwiperElementHeight + 24
      const isScrollToEnd = Math.abs(scrollHeight - offsetHeight - scrollTop) < 5

      if (!this.isMobile) {
        const serviceIntroElTop = document.getElementById('service-intro').offsetTop
        this.showStickyCard = scrollTop >= serviceIntroElTop - navbarHeight
      }

      for (let i = 0; i < scrollTargetSection.length; i++) {
        const currentArea = scrollTargetSection[i]
        const nextArea = scrollTargetSection[i + 1]
        const currentTop = currentArea.getBoundingClientRect().top
        const nextTop = nextArea ? nextArea.getBoundingClientRect().top : null
        if ((currentTop <= checkHeight && (!nextTop || nextTop > checkHeight)) ||
            (i === scrollTargetSection.length - 1 && isScrollToEnd)) {
          if (this.tabControl.selectedIndex !== i) {
            this.changeTab(i)
          }
          break
        }
      }
      if (isScrollToEnd && this.tabControl.selectedIndex !== scrollTargetSection.length - 1) {
        const lastIndex = scrollTargetSection.length - 1
        this.changeTab(lastIndex)
      }
    },
    handleRatingPopupSwitch (status) {
      if (status) {
        if (!this.ratingData.allList.length) {
          this.ratingData.allList = [...this.ratingData.topFiveList]
        }
        this.ratingData.isLoadingMore = false
        this.ratingData.noMore = false
        this.$nextTick(() => {
          if (!this.$refs.ratingDialogContent) return
          if (this.ratingData.orderIdToScroll) {
            this.scrollToSpecificRating(this.ratingData.orderIdToScroll)
          } else {
            this.$refs.ratingDialogContent.scrollTop = 0
          }
        })
      }
      this.ratingPopupSwitch = status
    },
    seeRatingDetail (orderId) {
      this.ratingData.orderIdToScroll = orderId
      this.handleRatingPopupSwitch(true)
    },
    handleRatingDialogScroll (event) {
      if (this.ratingData.isLoadingMore || this.ratingData.noMore) return
      const { scrollTop, scrollHeight, clientHeight } = event.target
      const isBottom = scrollTop + clientHeight + 30 >= scrollHeight
      if (isBottom) {
        this.loadMoreRatingData()
      }
    },
    async loadMoreRatingData () {
      try {
        if (this.ratingPagination.offset >= this.ratingPagination.total) {
          this.ratingData.noMore = true
          return
        }
        this.ratingData.isLoadingMore = true
        await this.$awaitSetTimeout(300)
        await this.fetchRatingData(
          this.ratingPagination.offset,
          this.ratingPagination.maxCount,
          'all'
        )
        this.ratingPagination.offset += this.ratingPagination.maxCount
      } catch (error) {
        console.error('載入更多評價失敗', error)
      } finally {
        this.ratingData.isLoadingMore = false
      }
    },
    scrollToSpecificRating (orderId) {
      const targetElement = document.querySelector(`[data-order-id="${orderId}"]`)
      if (targetElement && this.$refs.ratingDialogContent) {
        const topOffset = 60
        console.log('targetElement.offsetTop', targetElement.offsetTop)
        this.$refs.ratingDialogContent.scrollTo({
          top: targetElement.offsetTop - topOffset,
          behavior: 'smooth'
        })
        this.ratingData.orderIdToScroll = null
      }
    },
    async goToPurchasePage () {
      if (this.notInServeReason) {
        this.isShowNotServeModal = true
        return
      }
      if (this.introData.order_mode_id === 3) {
        if (!this.isApp) {
          this.$alert({
            title: '系統提示',
            message: '僅開放智生活App使用',
            persistent: true,
            btn: [
              {
                btnText: '確認',
                btnColor: 'primary',
                btnClick: () => {
                  this.$alert.close()
                }
              }
            ]
          })
          return
        }
        if (!this.$auth.loggedIn) {
          this.$alert({
            title: '註冊/登入會員',
            message: '此功能限定會員使用，現在就註冊/登入會員吧！',
            persistent: true,
            btn: [
              {
                btnText: '註冊/登入',
                btnColor: 'primary',
                btnClick: () => {
                  this.$alert.close()
                  this.$router.push({
                    name: 'auth-action',
                    params: { action: 'login' },
                    query: { redirect: this.$nuxt.$route.path }
                  })
                }
              },
              {
                btnText: '暫時不用',
                btnClick: () => {
                  this.$alert.close()
                }
              }
            ]
          })
          return
        }
        try {
          await this.canMakeAnAppointment()
        } catch (error) {
          this.$alert({
            title: '系統提示',
            message: '此服務尚有未結束諮詢單',
            persistent: true,
            btn: [
              {
                btnText: '立即前往',
                btnColor: 'primary',
                btnClick: () => {
                  this.$alert.close()
                  window.location.href = `${process.env.IN_APP_AD_URL}?page=supplierConsultation&params1=${this.serviceId}&params2=&referrer=`
                }
              }
            ]
          })
          return
        }
      }
      await this.$nuxt.$router.push({
        name: 'category-category-service-purchase',
        params: {
          service: this.serviceId,
          category: this.category
        }
      })
    },
    goToRedirectionPage () {
      this.$gaLogEvent('商品頁', `click_點我預約_導購_${this.serviceName}_${this.serviceId}`)
      let href = this.redirection.uri
      if (this.redirection.uri.includes('docs.google.com') &&
          this.redirection.uri.includes('entry.')) {
        // 導流制若為免費諮詢 uri 含 docs.google.com 及 entry.
        // 需把會員電話帶在uri後面
        href += this.$auth.user ? this.$auth.user.APhone : ''
      }
      // 叫車服務在 App 環境下需將 App 原生版本號帶入 uri 參數
      if (this.isTaxiService && this.isApp && this.$store.state.appNativeVersion) {
        const urlObject = new URL(href)
        urlObject.searchParams.set('appVersion', this.$store.state.appNativeVersion)
        href = urlObject.toString()
      }
      window.open(href, '_blank')
    },
    async canMakeAnAppointment () {
      try {
        await this.$axios.get(`/api/v2/Order/CanMakeAnAppointment/${this.serviceId}`)
        return Promise.resolve()
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    closePlatformConsultationTooltip () {
      this.platformConsultationTooltip.canShow = false
      this.platformConsultationTooltip.hasClosed = true
    },
    // 快速諮詢
    async goQuickConsultation () {
      if (!this.canClick) return // 防連點
      this.canClick = false
      setTimeout(() => {
        this.canClick = true
      }, 1000)
      // 未登入，待處理
      if (!this.$auth.loggedIn) {
        this.$alert({
          title: '註冊/登入會員',
          message: '此功能限定會員使用，現在就註冊/登入會員吧！',
          persistent: true,
          btn: [
            {
              btnText: '註冊/登入',
              btnColor: 'primary',
              btnClick: () => {
                this.$alert.close()
                this.$router.push({
                  name: 'auth-action',
                  params: { action: 'login' },
                  query: { toAppPage: 'quickConsultation', serviceId: this.serviceId }
                })
              }
            },
            {
              btnText: '暫時不用',
              btnClick: () => {
                this.$alert.close()
              }
            }
          ]
        })
        return
      }
      // 跳轉到 app 內快速諮詢(平台諮詢聊天室)
      window.location.href = `${process.env.IN_APP_AD_URL}?page=quickConsultation&params1=${this.serviceId}&referrer=`
    },
    goDailyProLine () {
      this.$gaLogEvent('加入line@', '')
      const lineLink = getServiceLineLink(this.serviceId)
      if (this.isApp) { // 藉由廣告架構，利用 app 的預設瀏覽器開啟 Line
        window.location.href = `${process.env.IN_APP_AD_URL}?page=thirdPartyLink&params1=${lineLink}&referrer=`
      } else {
        window.open(lineLink, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
$webMaxWidth: 1144px;
$swiperCardWidth: 365px;
$webXPadding: 3.75rem;
$mobileXPadding: 16px;
$mobileYPadding: 24px;

@mixin full-width-btn {
  font-size: pxTorem(18px);
  padding-top: pxTorem(14px) !important;
  padding-bottom: pxTorem(14px) !important;
  height: auto !important;
  font-weight: 600;
  width: 100%;
  @media screen and (max-width: $mobileWidth) {
    font-size: pxTorem(16px);
    padding-top: pxTorem(12px) !important;
    padding-bottom: pxTorem(12px) !important;
    border-radius: 10px;
  }
}

#service-intro-page {
  background-color: $color-background-secondary;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
@media screen and (max-width: $mobileWidth) {
  #service-intro-page {
    background-color: $color-background-primary;
  }
}

.section-container {
  max-width: $webMaxWidth;
  margin-left: auto;
  margin-right: auto;
  padding-left: $webXPadding;
  padding-right: $webXPadding;
  &__title {
    margin-left: pxTorem(12px);
    font-size: pxTorem(25px);
    font-weight: 600;
    position: relative;
    &::before {
      content: "";
      width: 4px;
      height: pxTorem(25px);
      background-color: $color-primary;
      position: absolute;
      top: 5px;
      left: -12px;
      border-radius: 100px;
    }
    &.with-mb {
      margin-bottom: pxTorem(32px);
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .section-container {
    max-width: $mobileWidth;
    padding-left: $mobileXPadding;
    padding-right: $mobileXPadding;
    padding-top: $mobileYPadding;
    width: 100%;
    background-color: $color-background-secondary;
    &__title {
      font-size: 18px;;
      margin-left: 12px;
      &::before {
        content: "";
        width: 4px;
        height: 18px;
        background-color: $color-primary;
        position: absolute;
        top: 5px;
        left: -12px;
        border-radius: 100px;
      }
      &.with-mb {
        margin-bottom: 20px ;
      }
    }
    &.with-mb {
      margin-bottom: 8px;
    }
    &.is-top {
      padding-top: 16px;
      padding-bottom: 12px;
    }
    &.with-paddingY {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
}

.service-breadcrumb {
  display: flex;
  align-items: center;
  font-size: pxTorem(15px);
  line-height: pxTorem(15px);
  color: $color-caption;
  margin-bottom: pxTorem(40px);
  margin-top: pxTorem(64px);
  &__item {
    text-decoration: none;
    color: $color-caption;
    &--active {
      color: $color-primary;
      font-weight: 600;
    }
    &:hover {
      color: $color-primary;
    }
  }
  &__arrow {
    margin: 0 pxTorem(4px);
    font-size: pxTorem(18px);
  }
}

.service-top-section {
  display: flex;
  gap: 4rem;
  width: 100%;
  &__left {
    max-width: 600px;
    min-width: 0;
    flex: 1 1 auto;
  }
  &__right {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    min-width: calc(100% - 600px - 4rem);
    max-width: calc(100% - 480px - 4rem);
  }
  &__btn {
    margin-top: pxTorem(28px);
  }
}
@media screen and (max-width: $mobileWidth) {
  .service-top-section {
    flex-direction: column;
    gap: 0;
    &__left {
      max-width: 100%;
      flex: none;
    }
    &__right {
      max-width: 100%;
      flex: none;
    }
  }
}

.service-banner {
  &__image {
    max-width: 600px;
  }
  &__empty {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-background-primary;
  }
  &__logo {
    width: 20%;
  }
}
@media screen and (max-width: $mobileWidth) {
  .service-banner {
    &__empty {
      width: 100%;
      height: 225px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $color-background-primary;
    }
    &__logo {
      width: 16%;
    }
  }
}

.banner-swiper {
  &__slide {
    max-width: 600px;
  }
  &__image {
    display: block;
    width: 100%;
  }
}

.payment-list {
  display: flex;
  align-items: center;
  margin-top: pxTorem(14px);
  margin-bottom: pxTorem(12px);
  flex-wrap: wrap;
  &__icon {
    font-size: pxTorem(18px);
    margin-right: pxTorem(8px);
  }
  &__item {
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-right: 8px;
      &::after {
        content: '';
        margin-left: 8px;
        height: 1rem;
        border-right: 1px solid $color-text-primary;
      }
    }
  }
  &__image {
    height: 20px;
    &.plus-pay {
      height: 18px;
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .payment-list {
    margin-top: 0;
    margin-bottom: 0;
    &__item {
      &:not(:last-child) {
        margin-right: 6px;
        &::after {
          content: '';
          margin-left: 6px;
        }
      }
    }
  }
}

.brief-content {
  position: relative;
  overflow: hidden;

  &:not(.brief-content--expanded) {
    max-height: 7em;
    transition: max-height 1s ease-in-out;
  }

  &--expanded {
    max-height: none;
    transition: max-height 1s ease-in-out;
  }

  &__text {
    line-height: 1.5;
  }

  &__gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.5em;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    pointer-events: none;
  }

  &__toggle {
    margin-top: pxTorem(20px);
    color: $color-primary;
    font-weight: 600;
  }
}

.purchase-btn {
  @include full-width-btn;
}

.service-bottom-fixed {
  position: fixed;
  z-index: 20;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #E3E3E3;
  background-color: $color-background-secondary;
  @include mobile-btn-container();
}

.horizontal-divider {
  margin-top: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid $color-border-primary;
}

.rating-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 100px;
  margin-bottom: pxTorem(24px);
  &__btn {
    display: flex;
    color: $color-primary;
    font-weight: 600;
    .icon {
      margin-left: 8px;
      &::before {
        color: $color-primary;
        font-size: pxTorem(24px);
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .rating-section {
    margin-top: 0;
    margin-bottom: 0;
    &__btn {
      font-size: 16px;
      .icon {
        font-size: 18px;
      }
    }
  }
}

.rating-dialog-content {
  padding: 0 40px;
  max-height: 70vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .rating-summary {
    margin-top: pxTorem(26px);
    margin-bottom: pxTorem(24px);
  }
  .rating-star-wrap {
    gap: 4px;
    &__icon {
      font-size: pxTorem(20px);
    }
  }
}
.rating-loading-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  gap: 12px;
  color: $color-caption;
  span {
    font-size: 14px;
  }
}

.rating-no-more {
  text-align: center;
  color: $color-caption;
  font-size: 14px;
  padding: 24px 0;
}
@media screen and (max-width: $mobileWidth) {
  .rating-dialog-content {
    padding: 0;
    max-height: 60vh;
    .rating-summary {
      flex-direction: column;
      margin-top: 24px;
      margin-bottom: 24px;
      gap: 16px;
      &__left {
        flex-direction: column-reverse;
        margin-left: 0;
        gap: 6px;
      }
    }
    .rating-star-wrap {
      &__icon {
        font-size: 19px;
      }
    }
    .rating-avg-wrap {
      margin-left: 0;
      &__number {
        font-size: 24px;
      }
    }
  }

}

// rating-swiper
@mixin pseudo-mask-background($direction) {
  content: '';
  width: calc((#{$swiperCardWidth} / 2) + 20px);
  background-image: linear-gradient($direction, transparent, #fff);
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
.rating-swiper-section {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: $color-background-secondary;
  &__container {
    position: relative;
    &::before {
      @include pseudo-mask-background(to left);
      left: 0;
    }
    &::after {
      @include pseudo-mask-background(to right);
      right: 0;
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .rating-swiper-section {
    padding-top: 24px;
    margin-bottom: 8px;
    &__container {
      &::before,
      &::after {
        display: none;
      }
    }
  }
}
.rating-swiper {
  padding: 20px 0;
  &__slide {
    width: $swiperCardWidth;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.06);
    transform: translateX(calc(-1 * #{$swiperCardWidth} / 2));
  }
}
@media screen and (max-width: $mobileWidth) {
  .rating-swiper {
    padding: 0;
    &__slide {
      width: auto;
      padding: 16px;
      background-color: $color-background-secondary;
      border-radius: 8px;
      border: 1px solid $color-border-primary;
      box-shadow: none;
      transform: translateX(0);
    }
  }
}
::v-deep .rating-swiper-button {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  border-radius: 50%;
  box-shadow: 0px 4px 8px 1px rgb(75 88 105 / 12%);
  z-index: 11;
  background-color: rgba(249, 249, 249, 0.8);
  cursor: pointer;
  i {
    font-size: pxTorem(20px);
    &::before {
      color: $color-text-primary;
    }
  }
  &--prev {
    left: $webXPadding;
  }
  &--next {
    right: $webXPadding;
  }
}
.mobile-rating-swiper-section {
  background-color: $color-background-secondary;
}
.mobile-rating-swiper {
  &__slide {
    padding: 16px;
    background-color: $color-background-secondary;
    border-radius: 8px;
    border: 1px solid $color-border-primary;
  }
}
.rating-card-list {
  padding: 16px;
  border-top: 1px solid $color-border-primary;
  &:last-child {
    border-bottom: 1px solid $color-border-primary;
  }
}
.mobile-rating-more {
  padding-left: pxTorem(28px);
  padding-right: pxTorem(28px);
  padding-top: pxTorem(16px);
  padding-bottom: pxTorem(24px);
  margin-bottom: pxTorem(8px);
  &__btn {
    @include full-width-btn;
    color: $color-primary !important;
  }
}

.not-in-serve-wrap {
  padding: 0 40px;
  .not-in-serve {
    padding: 0;
  }
}
@media screen and (max-width: $mobileWidth) {
  .not-in-serve-wrap {
    padding: 24px;
  }
}

// 優惠區域
.promotion-section{
  padding: 24px;
  margin-top: 32px;
  border-radius: 4px;
  border: 1px solid $color-border-primary;

  &__title {
    font-size: pxTorem(22px);
    font-weight: 600;
    margin-bottom: 12px;
  }
}
.mobile-promotion {
  max-width: $mobileWidth;
  padding-left: $mobileXPadding;
  padding-right: $mobileXPadding;
  padding-top: 14px;
  padding-bottom: 14px;
  margin-bottom: 8px;
  width: 100%;
  background-color: $color-background-secondary;
}

// tab
.tab-swiper__container {
  position: relative;
  background-color: $color-background-secondary;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  z-index: 15;
  display: none; // 桌面版初始狀態下隱藏
  &.scroll-fixed {
    display: block;
    position: fixed;
    top: 72px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }
}
#tab-swiper {
  width: 100%;
  color: $color-caption;
  padding: 0;
  box-sizing: border-box;
  .swiper-slide {
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-align: center;
    width: 140px;
    height: 45px;
    padding: 2px 10px 0;
    box-sizing: border-box;
    &.selected {
      color: $color-primary;
      font-weight: bold;
      &::after {
        content: "";
        position: absolute;
        height: 3px;
        width: 60%;
        background-color: $color-primary;
        z-index: 1;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .tab-swiper {
    &__wrapper {
      height: 45px;
    }
    &__container {
      display: block;
      position: relative;
      box-shadow: none;
    }
  }
  #tab-swiper {
    padding: 0;
    &.scroll-fixed {
      position: fixed;
      top: 0px;
      z-index: 10;
    }
    .swiper-slide {
      font-size: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      text-align: center;
      width: calc(100% / 4.5);
      height: 45px;
      padding: 2px 10px 0;
      box-sizing: border-box;
      &.selected {
        color: $color-primary;
        font-weight: bold;
        &::after {
          content: "";
          position: absolute;
          height: 3px;
          width: 70%;
          background-color: $color-primary;
          z-index: 1;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}

.detail-section {
  margin-top: 80px;
  display: flex;
  gap: pxTorem(80px);
}
@media screen and (max-width: $mobileWidth) {
  .detail-section {
    margin-top: 0;
    gap: 0;
    flex-direction: column;
  }
}
.service-detail-wrap {
  display: flex;
  flex-direction: column;
  width: calc(100% - 465px - 5rem);
  ::v-deep .v-html-content {
    all: revert;
    * {
      all: revert;
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .service-detail-wrap {
    width: 100%;
  }
}
.sticky-card {
  width: 465px;
  height: fit-content;
  padding-left: pxTorem(32px);
  padding-right: pxTorem(32px);
  padding-top: pxTorem(24px);
  padding-bottom: pxTorem(24px);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background-color: $color-background-secondary;
  border-radius: 12px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 130px;
  &__bottom {
    margin-top: pxTorem(28px);
  }
}
.service-contact {
  margin-top: pxTorem(56px);
  margin-bottom: pxTorem(140px);
  padding-bottom: pxTorem(80px);
  &__wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &__text {
    color: $color-primary;
    font-size: pxTorem(18px);
    font-weight: 600;
    margin-top: pxTorem(100px);
    margin-bottom: pxTorem(38px);
  }
}
@media screen and (max-width: $mobileWidth) {
  .service-contact {
    margin-top: 8px;
    margin-bottom: 136px;
    padding-bottom: $mobileYPadding;
    &__text {
      font-size: 16px;
      margin-top: 16px;
      margin-bottom: 24px;
    }
  }
}
.line-button {
  width: 122px;
  cursor: pointer;
}
@media screen and (max-width: $mobileWidth) {
  .line-button {
    width: 106px;
  }
}
.float-btn {
  pointer-events: none;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  right: 10px;
  bottom: calc(114px + var(--safe-area-inset-bottom));
  z-index: 20;
  &__image {
    pointer-events: auto;
    width: 64px;
    height: 64px;
  }
  &__tooltip {
    padding: 12px;
    margin-bottom: 18px;
    color: $color-text-inverse;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.76);
    position: relative;
    opacity: 0.93;
    &::after {
      content: "";
      position: absolute;
      bottom: -12px;
      right: 20px;
      width: 0;
      height: 0;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-top: 12px solid rgba(0, 0, 0, 0.76);
    }
  }
  &__tooltip-header {
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__tooltip-content {
    font-size: 14px;
  }
  &__tooltip-title {
    font-weight: bold;
  }
  &__tooltip-icon {
    pointer-events: auto;
    font-size: 16px;
  }
}
// transition
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter-to {
  opacity: 1;
}
</style>
